import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Main.vue'
import { Message } from "element-ui";
import Placeorder from '../views/placeOrder/PlaceOrder.vue'
import AllOrders from '../views/AllOrders.vue'
import ManageOrders from '../views/ManageOrders.vue'
import MyBill from '../views/myBill.vue'
import Invoice from '../views/Invoice.vue'
import ManagementBills from '../views/ManagementBills.vue'
import BillingDetails from '../views/independent/BillingDetails.vue'
import Payment from '../views/Payment.vue'
import Userinfo from '../views/Userinfo.vue'
import Audit from '../views/audit.vue'
import StoreManagement from '../views/storeManagement.vue'
import FreightSpace from '../views/FreightSpace.vue'
import ComeInAndGoOut from '../views/ck/ComeInAndGoOut.vue'
import packList from '../views/pack/packList.vue'
import PackView from '../views/pack/PackView.vue'
import GoodsReturn from '../views/GoodsReturn.vue'
import seoWeb from '../views/administration/seoWeb.vue' //营销入口
import Marketing from '../views/administration/marketingWeb.vue' //营销网址管理
import websitePage from '../views/administration/websitePage.vue' //营销网址填写数据
import article from '../views/administration/Article.vue' //添加/修改文章界面
import manage_web from '../views/administration/manage_web.vue' //管理营销网站列表
import business from '../views/placeOrder/Business.vue' //商业件下单
import Concentrated from '../views/placeOrder/Concentrated.vue'
import QuoteDetail from '../views/QuoteDetail.vue' //报价详情
import Inquire from '../views/placeOrder/inquire.vue' //查询报价
import LogisticsInfo from '@/views/LogisticsInfo.vue' //物流查询
import warehouse from '@/views/placeOrder/warehouse.vue'//仓库位置
import promotionAudit from '@/views/promotion/promotionAudit.vue'//提现审核
import monthlyBill from '@/views/MonthlyBill.vue'//月结账单
// ---------下面页面不需要登录即可进入---------
import Login from '../views/login.vue'  //登录界面
import examinePrice from '../views/notlogin/inpquer.vue' //查价
import logisticsInquer from '../views/notlogin/logisticsInquer.vue' //物流查询
import notLoginWarehouse from '../views/notlogin/not_login_warehouse.vue' //仓库查询

//-------------------------------------------------------------------------------------
import { apiUserData } from '../request/api'
import common from '../assets/js/common'
Vue.use(VueRouter)


const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {

  return originalPush.call(this, location).catch(err => err)

}
const routes = [

  {
    path: '/',
    redirect: '/index/placeOrder'
  },
  {
    path: '/examinePriceDetail',
    name: 'examinePriceDetail',
    component: () => import('../views/notlogin/examinePriceDetail.vue'),
  },
  {
    path: '/examinePrice',
    name: 'examinePrice',
    component: examinePrice,
  },
  {
    path: '/logisticsInquer',
    name: 'logisticsInquer',
    component: logisticsInquer,
  },
  {
    path: '/notLoginWarehouse',
    name: 'notLoginWarehouse',
    component: notLoginWarehouse,
  },

  {
    path: '/index',
    component: Main,
    children: [
      {
        path: 'promotionAudit',
        name: 'promotionAudit',
        component: promotionAudit,

      },
      {
        path: 'articleAdmini',
        name: 'ArticleAdmini',
        component: () => import('../views/administration/ArticleAdmini.vue'),
      },
      {
        name: 'warehouse',
        path: 'warehouse',
        component: warehouse,
      },
      {
        name: 'monthlyBill',
        path: 'monthlyBill',
        component: monthlyBill,
      },
      {
        name: 'LogisticsInfo',
        path: 'LogisticsInfo',
        component: LogisticsInfo,
      },
      {
        name: 'Inquire',
        path: 'Inquire',
        component: Inquire,
        meta: {
          keepAlive: true,
        }
      },
      {
        name: 'Concentrated',
        path: 'Concentrated',
        component: Concentrated
      },
      {
        name: 'business',
        path: 'business',
        component: business
      },
      {
        name: 'QuoteDetail',
        path: 'QuoteDetail',
        component: QuoteDetail,

      },
      {
        name: 'websitePage',
        path: 'websitePage',
        component: websitePage
      },
      {
        name: 'manage_web',
        path: 'manage_web',
        component: manage_web,
      },
      {
        name: 'Marketing',
        path: 'Marketing',
        component: Marketing,
        meta: {
          keepAlive: false
        }
      },
      {
        name: 'Userinfo',
        path: 'Userinfo',
        component: Userinfo
      },
      {
        name: 'Audit',
        path: 'Audit',
        component: Audit,
      },
      {
        naem: 'Payment',
        path: 'Payment',
        component: Payment,
      }, {
        naem: 'seoWeb',
        path: 'seoWeb',
        component: seoWeb
      }, {
        naem: 'BillingDetails',
        path: 'BillingDetails',
        component: BillingDetails
      }, {
        name: 'ComeInAndGoOut',
        path: 'ComeInAndGoOut',
        component: ComeInAndGoOut
      },
      {
        name: 'myBill',
        path: 'myBill',
        component: MyBill
      },
      {
        name: 'myMonthlyBile',
        path: 'myMonthlyBile',
        component: () => import('../views/myBill_yk.vue')
      },
      {
        name: 'messageList',
        path: 'messageList',
        component: () => import('../views/messageList.vue')
      },


      {
        name: 'article',
        path: 'article',
        component: article
      },
      {
        name: 'ManagementBills',
        path: 'ManagementBills',
        component: ManagementBills
      },
      {
        name: 'placeOrder',
        path: 'placeOrder',
        component: Placeorder,
        meta: {
          keepAlive: true,
        }

      }, {
        path: 'AllOrders',
        name: 'allOrders',
        component: AllOrders
      }, {
        name: 'ManageOrders',
        path: 'ManageOrders',
        component: ManageOrders

      }, {
        name: 'packList',
        path: 'packList',
        component: packList
      }, {
        name: 'PackView',
        path: 'PackView',
        component: PackView,
      }, {
        name: 'StoreManagement',
        path: 'StoreManagement',
        component: StoreManagement,
      },
      {
        name: 'FreightSpace',
        path: 'FreightSpace',
        component: FreightSpace,
      },
      {
        name: 'Invoice',
        path: 'Invoice',
        component: Invoice
      }, {
        name: 'GoodsReturn',
        path: 'GoodsReturn',
        component: GoodsReturn,
        meta: {
          title: '物品退货'
        }
      }
    ]
  },
  {
    path: '/login',
    component: Login
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.path === '/index/manageOrders') {
    apiUserData({
      uid: localStorage.getItem('uid'),
      permission: 1
    })
      .then(res => {
        if (common.isOrderManagement(res.permission, 'orderadmin') || res.role == 'admin' || res.role == 'kf') {
          next()
        } else {
          next('/')
          next();
        }
      })
  }
  //判断当前url地址是否为登入
  if (to.path === '/login') {
    next();
  } else {
    //如果不是则判断
    if (localStorage.getItem('vuex')) {
      let token = localStorage.getItem('vuex').Authorization;
      //如果token为空,或不存在跳转到登入
      if (token === null || token === '') {
        next('/login');
        next();
      } else {
        next();
      }
    } else {
      localStorage.setItem("toPath", to.fullPath);
      Message.error('您还未登入,请先登录');
      next('/login');
      next();
    }

  }
});

export default router

